/*
 * SolveX search helpers, shared by every search field in the theme (header
 * overlay, mobile drawer, search page).
 *
 * - Recent searches: kept in this browser's localStorage only, never sent to
 *   the store. Recorded when a search form is submitted and when a shopper
 *   follows a live suggestion. predictive-search.js asks for them to be drawn
 *   into the idle panel (snippets/solvex-search-idle.liquid) when a field is
 *   focused and still empty. Switched off by the theme setting
 *   "Remember each shopper's recent searches".
 * - The search page's document title: Shopify's own title counts every shade
 *   of a shade family, while the page shows one card per family, so the title
 *   is replaced with the server-rendered count the page actually shows.
 *
 * Every storage call is wrapped: private windows and blocked site data make
 * localStorage throw, and search must keep working without it.
 */
(function () {
  'use strict';

  if (window.SolvexSearch) return;

  var STORAGE_KEY = 'solvex-recent-searches';
  var MAX_RECENT = 6;
  var script = document.currentScript;
  var recentEnabled = !script || script.dataset.recent !== 'false';

  function readRecent() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? stored.filter(function (term) { return typeof term === 'string' && term; }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      if (list.length) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* Storage unavailable: recent searches simply are not kept. */
    }
  }

  function record(term) {
    if (!recentEnabled) return;
    var clean = String(term || '').replace(/\s+/g, ' ').trim();
    if (!clean || clean.length > 80) return;
    var lower = clean.toLowerCase();
    var list = readRecent().filter(function (existing) { return existing.toLowerCase() !== lower; });
    list.unshift(clean);
    writeRecent(list.slice(0, MAX_RECENT));
  }

  function renderRecent(panel) {
    var group = panel && panel.querySelector('[data-solvex-search-recent]');
    if (!group) return;
    var list = group.querySelector('[data-solvex-search-recent-list]');
    var base = panel.dataset.searchBase || '/search?q=';
    var terms = recentEnabled ? readRecent() : [];

    list.replaceChildren();
    terms.forEach(function (term) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.className = 'solvex-search-chip solvex-search-chip--recent';
      link.href = base + encodeURIComponent(term);
      link.textContent = term;
      item.appendChild(link);
      list.appendChild(item);
    });
    group.hidden = terms.length === 0;
  }

  function isSearchForm(form) {
    var action = form && form.getAttribute('action');
    return !!action && /\/search\/?$/.test(action.split('?')[0]);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isSearchForm(form)) return;
      var input = form.querySelector('input[name="q"]');
      if (input) record(input.value);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var clear = event.target.closest('[data-solvex-search-recent-clear]');
    if (clear) {
      event.preventDefault();
      writeRecent([]);
      var panel = clear.closest('[data-solvex-search-idle]');
      renderRecent(panel);
      panel?.closest('predictive-search')?.querySelector('input[type="search"]')?.focus();
      return;
    }

    var link = event.target.closest('predictive-search a[href]');
    if (!link) return;
    var field = link.closest('predictive-search').querySelector('input[type="search"]');
    if (field && field.value.trim()) record(field.value);
  });

  function syncSearchPage(scope) {
    var root = scope || document;
    var title = root.querySelector('[data-solvex-search-document-title]');
    if (title && title.textContent.trim()) document.title = title.textContent.trim();
  }

  function onReady() {
    var page = document.querySelector('[data-solvex-search-page]');
    if (page && page.dataset.terms) record(page.dataset.terms);
    syncSearchPage(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });
  else onReady();

  document.addEventListener('shopify:section:load', function (event) { syncSearchPage(event.target); });

  window.SolvexSearch = { record: record, renderRecent: renderRecent };
})();
